import { mutationTree, actionTree } from 'typed-vuex'
import { setState } from '~/lib/utils/store'
import { timeout } from '~/lib/utils/time'

const TIME_OUT = 10000
const MIN_VISITS = 3
const storeValue = JSON.parse(window.localStorage.getItem('showEngagementSurvey'))

export const namespaced = true

export const state = () => ({
  timer: timeout(TIME_OUT),
  visits: 0,
  showModal: undefined,
  isEngaged: false,
  isTimeoutExpired: false,
  sessionAppearingCondition: storeValue === null || storeValue
})

export const mutations = mutationTree(
  state,
  {
    setState
  }
)

export const actions = actionTree(
  { state, mutations },
  {
    changeSessionAppearingCondition({ commit }, condition: boolean) {
      window.localStorage.setItem('showEngagementSurvey', JSON.stringify(condition))
      // @ts-ignore
      commit('setState', { stateName: 'sessionAppearingCondition', data: condition })
    },
    visit({ state, commit }) {
      if (!state.sessionAppearingCondition) { return }
      // @ts-ignore
      state.timer.set(() => commit('setState', { stateName: 'isTimeoutExpired', data: true }))
    },
    leave({ state, commit }, { scholarshipId }) {
      if (!state.sessionAppearingCondition) { return }
      state.timer.clear()

      if (state.isTimeoutExpired && !state.isEngaged) {
        if ((state.visits + 1) % MIN_VISITS === 0) {
          commit('setState', { stateName: 'showModal', data: scholarshipId })
        }
        commit('setState', { stateName: 'visits', data: state.visits + 1 })
      }

      commit('setState', { stateName: 'isTimeoutExpired', data: false })
      commit('setState', { stateName: 'isEngaged', data: false })
    }
  }
)
